module.exports = __webpack_public_path__ + "img/appImage-betaFeature.9240e809.svg";